import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import React from "react";
import {
  blackColor,
  blackShade19,
  blueColor04,
  greyColor40,
  whiteColor,
  yellowColor,
  yellowShade03,
} from "../../../configs/styles/muiThemes";
import FormInputBox from "../../../components/Input/FormInputBox";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { textTwoLines } from "../../../utils/styles";
import NotSyncedSkuDropdown from "../Components/NotSyncedSkuDropdown";

const GetSkuDetailsTab = ({
  skuData,
  setSkuData,
  error,
  setError,
  onNext,
  loader,
  currentPage,
  draftProducts,
  handleContinueWithDraft,
  commerceInfo,
}) => {
  return (
    <Box p="20px 0 5px">
      <Grid container>
        <Grid item md={5}>
          <Typography
            fontSize={15}
            fontWeight={600}
            lineHeight="18px"
            color={blackShade19}
            mb={1}
          >
            Add New SKU Ids
          </Typography>

          <Typography
            fontSize={13}
            fontWeight={400}
            lineHeight="15px"
            color={greyColor40}
          >
            Provide one or more SKUs as comma-separated text.
          </Typography>

          <Box width="400px" mt={1.5}>
            {commerceInfo?.info?.catalogPartnerInfo?.[0]?.catalogPartner?.toLowerCase() ===
            "buymore" ? (
              <NotSyncedSkuDropdown
                value={skuData}
                onChange={(value) => {
                  setSkuData(value);
                  if (error) {
                    setError("");
                  }
                }}
                commerceInfo={commerceInfo}
                error={error}
                setError={setError}
              />
            ) : (
              <FormInputBox
                hideLabel
                placeholder="Enter SKU Ids"
                value={skuData}
                onChange={({ target }) => {
                  setSkuData(target?.value);
                  if (error) {
                    setError("");
                  }
                }}
                error={error}
                autoComplete="off"
              />
            )}

            <Box display="flex">
              <Button
                disableElevation
                variant="contained"
                sx={styles.btn}
                endIcon={<ChevronRightIcon color="inherit" sx={{ ml: -1 }} />}
                onClick={onNext}
                startIcon={
                  loader ? <CircularProgress size={16} color="inherit" /> : null
                }
              >
                NEXT
              </Button>
            </Box>
          </Box>
        </Grid>

        {currentPage == "provide-sku" && draftProducts?.length > 0 && (
          <>
            <Grid item md={1.2}>
              <Typography fontSize={13} mt={6}>
                OR
              </Typography>
            </Grid>

            <Grid item md={5.8}>
              <Typography
                fontSize={15}
                fontWeight={600}
                lineHeight="18px"
                color={blackShade19}
                mb={1}
              >
                Continue With {draftProducts?.length || 0} Draft Products
              </Typography>

              <Typography
                fontSize={13}
                fontWeight={400}
                height="50px"
                lineHeight="24px"
                color={greyColor40}
                sx={{ ...textTwoLines }}
              >
                SKU Ids :{" "}
                {draftProducts?.slice(0, 10)?.map((item) => `${item?.skuId}, `)}
              </Typography>

              <Box width="400px" mt={1.5}>
                <Box display="flex">
                  <Button
                    disableElevation
                    variant="contained"
                    sx={styles.continueBtn}
                    endIcon={
                      <ChevronRightIcon color="inherit" sx={{ ml: -1 }} />
                    }
                    onClick={handleContinueWithDraft}
                  >
                    Continue
                  </Button>
                </Box>
              </Box>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default GetSkuDetailsTab;

const styles = {
  btn: {
    fontSize: 13,
    fontWeight: 500,
    color: blackColor,
    backgroundColor: yellowColor,
    padding: "7px 30px",
    borderRadius: "7px",
    "&:hover": {
      color: yellowColor,
      backgroundColor: whiteColor,
    },
    "&.Mui-disabled": {
      border: "none",
    },
  },

  continueBtn: {
    fontSize: 12,
    fontWeight: 600,
    color: blueColor04,
    border: `1px solid ${blueColor04}`,
    backgroundColor: whiteColor,
    padding: "7px 30px",
    borderRadius: "5px",
    "&:hover": {
      color: whiteColor,
      backgroundColor: blueColor04,
    },
    "&.Mui-disabled": {
      border: "none",
    },
  },
};
